import { render, staticRenderFns } from "./SharedRatesModel.vue?vue&type=template&id=7b3b8712"
import script from "./SharedRatesModel.vue?vue&type=script&lang=js"
export * from "./SharedRatesModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports